import React from 'react';
import { Link } from 'react-router';
import styles from './styles.scss';

function StartupSubFold () {
  return (
    <div className="container-fluid main-container mt100">
      <div className="col-md-10 col-center col-sm-12">
        <div className={styles.subFold}>
          <p className="lsh demi-bold alt-text text-center">
            Followed by...
          </p>
          <h1 className="bold mb200 text-center lsh">
            "So...how do I start??"
          </h1>
          <h2 className={`${styles.subHeading} bold lsh mb50`}>
            <span className={styles.blueHighlight}>Stick to the essentials:</span> a plan, a logo, and marketing content.
          </h2>
          <p className={`${styles.details} lsh mb20`}>
            Starting a company is a marathon, but you can get ahead by starting
            with a validated plan and good design. In 30 days, you’ll have
            everything you need to pitch investors, find cofounders, and build
            hype before your launch.
          </p>
          <p className={`${styles.details} lsh mb20`}>
            One of the biggest mistakes founders make is starting out in the
            wrong direction. Whether it’s trying to tackle too much of the
            market or rushing into building a product, starting wrong can waste
            money or even kill a startup months in.
          </p>
          <p className={`${styles.details} lsh mb20`}>
            We aim to minimize this by carefully thinking through our founder’s
            ideas and developing a plan to best serve their users' needs. Next,
            we provide all the digital assets needed to start a company:
            branding, app frameworks, and marketing materials.
          </p>
          <p className={`${styles.details} lsh mb20`}>
            Every founder works with a product manager to develop an actionable
            plan for starting their company and building their first product.
            Then, a team of designers works to structure the app and brand visuals.
          </p>
          <p className={`${styles.details} lsh mb20`}>
            We're only accepting 5 startups into the project at a time.
            Apply below to get started:
          </p>
          <Link to={{ pathname: '/startup-application'}} className="btn btn-dc-blue mt50">
            APPLY NOW
          </Link>
        </div>
      </div>
    </div>
  );
}

export default StartupSubFold;



// WEBPACK FOOTER //
// ./src/components/StartupSubFold/index.js